import React, { Fragment } from 'react';
import renderDropZoneMultipleField from '../../../../shared/components/form/DropZoneMultiple';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Card, CardBody, Col, Button, ButtonToolbar } from 'reactstrap';

const UploadingMultipleImages = ({ images, handleChargeImages }) => {
    return (<Fragment >
        <Card>
            <CardBody>
                <form className="form" onSubmit={handleChargeImages}>
                    <Field 
                    value={images}
                    onChange={(files) => {
                        handleChargeImages(files);
                    }} 
                    name="files" 
                    component={renderDropZoneMultipleField} />
                </form>
            </CardBody>
        </Card>
    </Fragment>)
};

UploadingMultipleImages.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
};

export default reduxForm({
    form: 'drop_files_form', // a unique identifier for this form
})(UploadingMultipleImages);
